import { inject, toRefs, watch, ref, Ref, nextTick } from 'vue'
import { IComboBoxEnumProps } from './combobox.type'
import type { CommonFn } from '@/common/common-fn'
import { isEqual, cloneDeep } from 'lodash'

const useComboBoxEnum = (props: IComboBoxEnumProps) => {
  const storeItems: Ref<any[]> = ref([])
  const commonFn = inject<CommonFn>('$commonFn')
  const { enumName, includeKeys } = toRefs(props)

  storeItems.value = commonFn?.getEnumData(enumName.value, includeKeys.value) as any[]

  watch([enumName, () => [...includeKeys.value]], async ([newEnum, newKeys]) => {
    await loadStoreItem(newEnum, newKeys)
  })

  const loadStoreItem = async (enumName: string, includeKeys: string[]) => {
    storeItems.value = []
    await nextTick()
    storeItems.value = commonFn?.getEnumData(enumName, includeKeys) as any[]
  }

  return {
    storeItems
  }
}

export default useComboBoxEnum
